export const dtiysTitle = "DTIYS Challenges"
export const dtiysData = [
    {
        label:'By silka',
        path:'/pages/dtiys/silka', 
        component:'ChallengeSilka',
        previewimage:[
            {
                imageName:'Draw This in your style by Silka',
                imagePath:'/assets/images/projects/fanart/dtiys_silka20k.png',
                projectPath:'/pages/dtiys/silka',
            }
        ],
        projectimages:[
            {
                imageName:'By Silka',
                imagePath:'/assets/images/projects/fanart/dtiys_silka20k.png',
                imageDescription:'Find the Link to the post with the reference (on the second slide) here: \n<Link href="https://www.instagram.com/p/ChkJrNlO8ra/?img_index=1">Reference Link</Link>.'
            },
        ]

    },
    {
        label:'By bellebubben',
        path:'/pages/dtiys/bellebubben', 
        component:'ChallengeBellebubben',
        previewimage:[
            {
                imageName:'Draw this in your style by Bellebubben',
                imagePath:'/assets/images/projects/fanart/bellebubben-dtiys.png',
                projectPath:'/pages/dtiys/bellebubben', 
            }
        ],
        projectimages:[
            {
                imageName:'',
                imagePath:'/assets/images/projects/fanart/bellebubben-dtiys.png',
                imageDescription:'Find the Link to the post with the reference (on the second slide) here: \n<Link href="https://www.instagram.com/p/CgW3XdGuJor/?img_index=1">Reference Link</Link>.'
            },
        ]

    },
    {
        label:'By cookysparks',
        path:'/pages/dtiys/cookysparks', 
        component:'ChallengeCookysparks',
        previewimage:[
            {
                imageName:'Draw this in your style by cookysparks',
                imagePath:'/assets/images/projects/fanart/COOKYSPARKS_dtiys.png',
                projectPath:'/pages/dtiys/cookysparks', 
            }
        ],
        projectimages:[
            {
                imageName:'',
                imagePath:'/assets/images/projects/fanart/COOKYSPARKS_dtiys.png',
                imageDescription:'Find the Link to the post with the reference here: \n<Link href="https://www.instagram.com/p/CfJi_ukuWD9/">Reference Link</Link>.'
            },
        ]

    },
    {
        label:'By cyarine',
        path:'/pages/dtiys/cyarine', 
        component:'ChallengeCyarine',
        previewimage:[
            {
                imageName:'Draw this in your style by Cyarine',
                imagePath:'/assets/images/projects/fanart/cyarine-dtiys.png',
                projectPath:'/pages/dtiys/cyarine', 
            }
        ],
        projectimages:[
            {
                imageName:'By Cyarine',
                imagePath:'/assets/images/projects/fanart/cyarine-dtiys.png',
                imageDescription:'Find the Link to the post with the reference (on the second slide) here: \n<Link href="https://www.instagram.com/p/Ce3rq_rOb8b/?img_index=1">Reference Link</Link>.'
            },
        ]

    },
    {
        label:'By nymeriaa for 12k followers',
        path:'/pages/dtiys/nymeriaa12k', 
        component:'ChallengeNymeriaa',
        previewimage:[
            {
                imageName:'Draw this in your style by Nymeriaa',
                imagePath:'/assets/images/projects/fanart/dtiys_nymeriaa12k.png',
                projectPath:'/pages/dtiys/nymeriaa12k', 
            }
        ],
        projectimages:[
            {
                imageName:'',
                imagePath:'/assets/images/projects/fanart/dtiys_nymeriaa12k.png',
                imageDescription:'Find the Link to the post with the reference (on the second slide) here: \n<Link href="https://www.instagram.com/p/ChpUc2CugAv/?img_index=1">Reference Link</Link>.'
            },
        ]

    },
    {
        label:'By squiddyinks',
        path:'/pages/dtiys/squiddyinks', 
        component:'ChallengeSquiddyInks',
        previewimage:[
            {
                imageName:'Draw this your style By squiddyinks',
                imagePath:'/assets/images/projects/fanart/squiddyinks-dtyis.png',
                projectPath:'/pages/dtiys/squiddyinks', 
            }
        ],
        projectimages:[
            {
                imageName:'',
                imagePath:'/assets/images/projects/fanart/squiddyinks-dtyis.png',
                imageDescription:'Find the Link to the post with the reference (on the second slide) here: \n<Link href="https://www.instagram.com/p/CgHtBPtru5y/?img_index=1">Reference Link</Link>.'
            },
        ]

    },
    {
        label:'Oshunredraw Challenge by artbyrisotoo',
        path:'/pages/dtiys/oshunredraw-artbyrisotoo', 
        component:'ChallengeArtbyrisotoo',
        previewimage:[
            {
                imageName:'Oshunredraw Challenge by artbyrisotoo',
                imagePath:'/assets/images/projects/fanart/oshunredraw2.png',
                projectPath:'/pages/dtiys/oshunredraw-artbyrisotoo', 
            }
        ],
        projectimages:[
            {
                imageName:'',
                imagePath:'/assets/images/projects/fanart/oshunredraw2.png',
                imageDescription:'Find the Link to the post with the reference (on the second slide) here: \n<Link href="https://www.instagram.com/p/CewMspNuWsl/?img_index=1">Reference Link</Link>.'
            },
        ]

    },
    {
        label:'By jorioux',
        path:'/pages/dtiys/jorioux', 
        component:'ChallengeJorioux',
        previewimage:[
            {
                imageName:'Draw this in your style By jorioux',
                imagePath:'/assets/images/projects/fanart/jorioux-dtiys.png',
                projectPath:'/pages/dtiys/jorioux', 
            }
        ],
        projectimages:[
            {
                imageName:'',
                imagePath:'/assets/images/projects/fanart/jorioux-dtiys.png',
                imageDescription:'Find the Link to the post with the reference (on the second slide) here: \n<Link href="https://www.instagram.com/p/Ce1PAx7rlbM/?img_index=2">Reference Link</Link>.'
            },
        ]

    },
]